//--------------------------------------- Official-server --------------------------------------------
const URLS = {
    AUTH_URL: "https://app.manehblog.com/auth/api/v1",
    ADMIN_URL: "https://app.manehblog.com/admin/api/v1",
    MEDIA_URL: "https://app.manehblog.com/file/api/v1",
    HOST_MEDIA_URL: "https://app.manehblog.com/file",
}

// const URLS = {
//     AUTH_URL: "http://5.189.158.104:4000/api/v1",
//     ADMIN_URL: "http://5.189.158.104:4001/api/v1",
//     MEDIA_URL: "http://5.189.158.104:4003/api/v1",
//     HOST_MEDIA_URL: "http://5.189.158.104:4003",
// }

//--------------------------------------- 4Steps-server --------------------------------------------

// const URLS = {
//     AUTH_URL: "http://173.212.233.220:3300/api/v1",
//     ADMIN_URL: "http://173.212.233.220:3301/api/v1",
//     MEDIA_URL: "http://173.212.233.220:3303/api/v1",
//     HOST_MEDIA_URL: "http://173.212.233.220:3303",
// }


const { AUTH_URL, ADMIN_URL, MEDIA_URL, HOST_MEDIA_URL, } =URLS
    // process.env.REACT_APP_ENVIRONMENT === 'production'
    // ? OFFICIAL_URLS
    // : TESTING_URLS;

export const _urlOauth = AUTH_URL ;
export const _urlMedia = MEDIA_URL + "/file";
export const _urlLanguages = ADMIN_URL + "/language";
export const _urlOthers = ADMIN_URL + "/others";
export const _urlContact = ADMIN_URL + "/contact";
export const _urlModerator = ADMIN_URL + "/moderator";
export const _urlStaticTexts = ADMIN_URL + "/static-texts";
export const _urlSlider = ADMIN_URL + "/slider";
export const _urlAdvertisement = ADMIN_URL + "/advertisement";
export const _urlBanner = ADMIN_URL + "/banners";
export const _urlCustomPages = ADMIN_URL + "/dynamic-page";
export const _urlAbout = ADMIN_URL + "/about";
export const _urlBlogs = ADMIN_URL + "/blog";
export const _urlSubscribe = ADMIN_URL + "/subscriber";
export const _urlMenu = ADMIN_URL + "/menu";

export const _hostMedia = HOST_MEDIA_URL;

